import { useState } from 'react';

function CsvUploadDialog({ onClose, onUpload }) {
  const [sourceName, setSourceName] = useState('');
  const [csvContent, setCsvContent] = useState('');
  const [isPpr, setIsPpr] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (!sourceName.trim()) {
      setError('Source name is required');
      return;
    }
    if (!csvContent.trim()) {
      setError('CSV content is required');
      return;
    }

    const scoringFormat = isPpr ? 'ppr' : 'standard';
    setUploading(true);
    try {
      await onUpload(sourceName.trim(), csvContent.trim(), scoringFormat);
      onClose();
    } catch (err) {
      const msg = err.response?.data?.error?.message || err.message;
      setError(msg);
    } finally {
      setUploading(false);
    }
  }

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => setCsvContent(ev.target.result);
    reader.readAsText(file);
  }

  return (
    <div className='modal-overlay' onClick={onClose}>
      <div className='modal' onClick={(e) => e.stopPropagation()}>
        <h2>Upload Rankings CSV</h2>
        {error && <div className='error-banner'>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className='form-group'>
            <label>Source Name</label>
            <input
              type='text'
              className='input'
              style={{ width: '100%' }}
              placeholder='e.g., My Custom Rankings'
              value={sourceName}
              onChange={(e) => setSourceName(e.target.value)}
            />
          </div>
          <div className='form-group'>
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
              <input
                type='checkbox'
                checked={isPpr}
                onChange={(e) => setIsPpr(e.target.checked)}
              />
              PPR rankings
            </label>
          </div>
          <div className='form-group'>
            <label>CSV File</label>
            <input type='file' accept='.csv' onChange={handleFileChange} />
          </div>
          <div className='form-group'>
            <label>Or paste CSV content</label>
            <textarea
              placeholder={'Rank,Player,Position,Team\n1,Patrick Mahomes,QB,KC\n2,Josh Allen,QB,BUF'}
              value={csvContent}
              onChange={(e) => setCsvContent(e.target.value)}
            />
          </div>
          <div className='modal-actions'>
            <button type='button' className='btn btn-secondary' onClick={onClose}>
              Cancel
            </button>
            <button type='submit' className='btn btn-primary' disabled={uploading}>
              {uploading ? 'Uploading...' : 'Upload'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CsvUploadDialog;
